"use client";

import { useEffect } from "react";

const clickableSelector = 'button, a[href], [role="button"]';
const feedbackAttribute = "data-click-feedback";
const feedbackDurationMs = 700;

export function ClickFeedbackListener() {
  useEffect(() => {
    function handlePointerDown(event: PointerEvent) {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      const clickable = target.closest(clickableSelector);

      if (!(clickable instanceof HTMLElement) || !canShowFeedback(clickable)) {
        return;
      }

      clickable.setAttribute(feedbackAttribute, "true");
      window.setTimeout(() => {
        clickable.removeAttribute(feedbackAttribute);
      }, feedbackDurationMs);
    }

    document.addEventListener("pointerdown", handlePointerDown, { capture: true });

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, { capture: true });
    };
  }, []);

  return null;
}

function canShowFeedback(element: HTMLElement) {
  if (element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true") {
    return false;
  }

  if (element instanceof HTMLButtonElement && element.disabled) {
    return false;
  }

  return true;
}
